import { Navigate, Route, Routes } from 'react-router-dom'
import Applications from './Applications'
import ApplicationDetailsPage from './pages/application-details'
import { MigrationPage } from '../migration/MigrationPage'

export default function ApplicationRoutes() {
    return (
        <Routes>
            <Route index element={<Applications />} />
            <Route path="multi-mc" element={<MigrationPage />} />
            <Route path=":projectName" element={<ApplicationDetailsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
